import { render, staticRenderFns } from "./SubunitPlan.vue?vue&type=template&id=479cbe43&scoped=true&"
import script from "./SubunitPlan.vue?vue&type=script&lang=js&"
export * from "./SubunitPlan.vue?vue&type=script&lang=js&"
import style0 from "./SubunitPlan.vue?vue&type=style&index=0&id=479cbe43&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "479cbe43",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/mnt/c/Users/wbreu/Documents/code/personal/the-unit-planner/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('479cbe43', component.options)
    } else {
      api.reload('479cbe43', component.options)
    }
    module.hot.accept("./SubunitPlan.vue?vue&type=template&id=479cbe43&scoped=true&", function () {
      api.rerender('479cbe43', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/SubunitPlan.vue"
export default component.exports